import React from "react";
import { View, Image, Text, StyleSheet, Platform, TouchableOpacity } from "react-native";
import { COLORS, STRINGS } from "../../constants";
import noResults from "../../assets/images/no-results.png";
import AppSettings from "../../storage/appSettings";
/**
 * NoResults.jsx
 *
 * This component displays a message when no results are found.
 * It includes an image and a text message to inform users of the empty state.
 */
const NoResults = ({ refresh, resultsCount }) => {
  const connectionError = AppSettings((state) => state.connectionError);

  return (
    <View style={styles.centerContainer} testID="no-results">
      {connectionError && (
        <View>
          <Text style={styles.noResultsText}>{STRINGS.connectionError}</Text>
          <TouchableOpacity style={styles.refreshContainer} onPress={refresh}>
            <Text style={styles.refreshText}>{STRINGS.refresh}</Text>
          </TouchableOpacity>
        </View>
      )}
      {!connectionError && resultsCount === 0 && (
        <View>
          <Image source={noResults} style={styles.errorImage} />
          <Text style={styles.noResultsText}>{STRINGS.noResults}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  centerContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  errorImage: {
    width: 100,
    height: 100,
    resizeMode: "contain",
    marginBottom: 8,
    textyAlign: "center",
  },
  noResultsText: {
    fontSize: 16,
    color: COLORS.textDark,
    fontWeight: "bold",
    textAlign: "center",
  },
  refreshContainer: {
    marginTop: 24,
    alignItems: "center",
    paddingHorizontal: 18,
    paddingVertical: 12,
    backgroundColor: COLORS.blueBackground,
    borderRadius: 8,
    borderColor: COLORS.secondary,
    borderWidth: Platform.OS == "web" ? 2 : 1.5,
    width: "auto",
  },
  refreshText: {
    backgroundColor: COLORS.blueBackground,
    fontSize: 16,
    color: COLORS.secondary,
    fontWeight: "bold",
    lineHeight: 24,
  },
});

export default NoResults;
